import OtherMasterList from '../StaticComponent/OtherMasterList';
import AgeRangemasterList from '../StaticComponent/AgeRangemasterList';
import SectionmasterList from '../StaticComponent/SectionmasterList';
import CommonRiskFactorList from '../StaticComponent/CommonRiskFactorList';
export const customComponentMap = {   
    ageRange: AgeRangemasterList,
    section: SectionmasterList,
    others: OtherMasterList,
    age: CommonRiskFactorList,
}

export const customComponentSettings = {
    "age": {
        'create_url': 'ageRiskFactor/create',
        'update_url': 'ageRiskFactor/update',
        'get_url': 'ageRiskFactor/getAgeList',
        'permission_key': 'riskFactors',
        'formKey': 'age',
        'dataType': 'numeric',
        'riskFactor': 'ageRiskFactor',
    }, 

};